import axios from "axios";
import {
  levels1Requested,
  levels1RequestFailed,
  levels1RequestSucceeded,
} from "../slices/GetLevels1Slice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Menu/GetLevels1ByCountry?country=${encodeURIComponent(selectedCountry)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GetLevels1 = () => async (dispatch) => {
  try {
    dispatch(levels1Requested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(levels1RequestSucceeded(response.data));
  } catch (error) {
    dispatch(levels1RequestFailed(error.message));
  }
};
